export default {
	LeftBlock: "Vertical-droppable-field",
	RightBlock: "Vertical-droppable-field",
	BottomBlock: "Bottom-droppable-field",
	Finance: "Finance-droppable-field",
	Research: "Search-droppable-field",
	Purchase: "Purchase-droppable-field",
	Production: "Production-droppable-field"
}